import React, { useState, useEffect } from 'react';
//import TableOfContents from 'src/components/PDF/TableOfContents/TableOfContents';
import PDFControlPanel from 'src/components/PDF/PDFControlPanel/PDFControlPanel';
import { Document, Page } from 'react-pdf';
import useStyles from 'src/components/PDF/PDFPreviewStyles';
import './PDFPreviewStyles.css';
import { Loading as LoadingComponent } from 'react-admin';

// Configure the PDF.js worker
import { pdfjs } from 'react-pdf';
// Use CDNJS for more reliable worker loading
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFPreview = ({ pdfUrl, nextPdfUrl, prevPdfUrl, downloadLink, isOnMediaPage }) => {
  const classes = useStyles({ isOnMediaPage });
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);
  const [rotation, setRotation] = useState(0);
  const [pageWidth, setPageWidth] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  // Hide outline/thumbnail by default
  const [showOutline, setShowOutline] = useState(false);

  // Preload next and previous PDFs
  useEffect(() => {
    const preloadPDF = async (url) => {
      if (!url) return;
      try {
        const response = await fetch(url, { method: 'HEAD' });
        if (response.ok) {
          // Create a hidden iframe to preload the PDF
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = url;
          document.body.appendChild(iframe);
          setTimeout(() => document.body.removeChild(iframe), 5000); // Remove after 5 seconds
        }
      } catch (error) {
        console.error('Error preloading PDF:', error);
      }
    };

    if (nextPdfUrl) preloadPDF(nextPdfUrl);
    if (prevPdfUrl) preloadPDF(prevPdfUrl);
  }, [nextPdfUrl, prevPdfUrl]);


  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
    setPageWidth(window.innerWidth);
    setIsLoaded(true);
  };
  const rotateClockwise = () => {
    setRotation(rotation + 90);
  };
  const rotateCounterclockwise = () => {
    setRotation(rotation - 90);
  };

  const [useFallback, setUseFallback] = useState(false);
  const [loadAttempted, setLoadAttempted] = useState(false);

  useEffect(() => {
    // Reset state when URL changes
    setUseFallback(false);
    setLoadAttempted(false);
    setIsLoaded(false);
  }, [pdfUrl]);

  // Auto-switch to fallback if loading takes too long
  useEffect(() => {
    if (pdfUrl && !isLoaded && !useFallback) {
      const timer = setTimeout(() => {
        if (!isLoaded && loadAttempted) {

          setUseFallback(true);
        }
      }, 3000); // Wait 3 seconds before showing fallback
      return () => clearTimeout(timer);
    }
  }, [pdfUrl, isLoaded, useFallback, loadAttempted]);

  // Add custom styles to hide the PDF.js sidebar and improve scrolling/cursor behavior
  useEffect(() => {
    // This adds a style to hide the thumbnail sidebar when PDF loads and improves user interaction
    const style = document.createElement('style');
    style.textContent = `
      .react-pdf__Document {
        display: flex;
        flex-direction: column;
      }
      /* Hide the thumbnail sidebar by default */
      .react-pdf__Outline,
      .react-pdf__Document--hasOutline,
      .react-pdf__Document .react-pdf__message,
      .rpv-thumbnail__container,
      .rpv-sidebar-content {
        display: none !important;
      }
      /* Make the main content take full width */
      .react-pdf__Page {
        width: 100% !important;
        margin: 0 auto;
      }
      /* Add grab cursor for better UX */
      .react-pdf__Page:hover {
        cursor: grab;
      }
      .react-pdf__Page:active {
        cursor: grabbing;
      }
      /* Make sure tables in PDF don't overflow */
      table {
        width: 100% !important;
        table-layout: fixed;
      }
      td, th {
        word-wrap: break-word;
        overflow-wrap: break-word;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className={classes.pdfWrapper}>
      <div className="pdf-container-no-sidebar" style={{ width: '100%', backgroundColor: 'transparent' }}>
        {!useFallback && pdfUrl && (
          <div className={classes.pdfDocument} style={{
              opacity: isLoaded ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out'
            }}>
            <Document
              file={{ url: pdfUrl, withCredentials: false }}
              onLoadSuccess={(pdf) => {
                onDocumentLoadSuccess(pdf);
              }}
              onLoadError={(err) => {
                console.error('react-pdf load error:', err);
                setLoadAttempted(true);
                setUseFallback(true);
              }}
              onSourceError={(err) => {
                console.error('react-pdf source error:', err);
                setLoadAttempted(true);
                setUseFallback(true);
              }}
              options={{ disableStream: true }}
              noData="Loading PDF..."
              renderMode="canvas"
              loading={<LoadingComponent />}
            >
            <div className={classes.controlPanel} style={{ width: isOnMediaPage ? Math.max(pageWidth * 0.7, 500) : Math.max(pageWidth * 0.8, 500) }}>
              <PDFControlPanel
                rotateClockwise={rotateClockwise}
                rotateCounterclockwise={rotateCounterclockwise}
                numPages={numPages}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                scale={scale}
                setScale={setScale}
                pdfUrl={pdfUrl}
                downloadLink={downloadLink}
                isOnMediaPage={isOnMediaPage}
              />
            </div>
            <div style={{
              width: '100%',
              overflow: 'auto',
              cursor: 'grab',
              height: 'calc(100% - 40px)',
              position: 'relative',
              WebkitOverflowScrolling: 'touch'
            }}>
              <Page
                className={classes.pdfPage}
                pageNumber={pageNumber}
                rotate={rotation}
                scale={scale}
                width={isOnMediaPage ? Math.max(pageWidth * 0.7, 500) : Math.max(pageWidth * 0.8, 500)}
              />
            </div>
          </Document>
        </div>
        )}

        {/* Integrated fallback display */}
        {useFallback && pdfUrl && (
          <div className={classes.pdfDocument} style={{ height: '100%' }}>
            <div className={classes.controlPanel} style={{ width: '100%' }}>
              <PDFControlPanel
                rotateClockwise={rotateClockwise}
                rotateCounterclockwise={rotateCounterclockwise}
                numPages={1}
                pageNumber={1}
                setPageNumber={() => {}}
                scale={scale}
                setScale={setScale}
                pdfUrl={pdfUrl}
                downloadLink={downloadLink}
                isOnMediaPage={isOnMediaPage}
              />
            </div>
            <div
              style={{
                width: '100%',
                height: 'calc(100% - 60px)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                transform: `rotate(${rotation}deg)`,
                transition: 'transform 0.3s ease-in-out',
                transformOrigin: 'center center',
                overflow: 'auto',
                cursor: 'grab',
                position: 'relative',
                WebkitOverflowScrolling: 'touch'
              }}
            >
              {/* Use iframe to hide browser's native PDF controls */}
              <iframe
                src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                type="application/pdf"
                width="100%"
                height="100%"
                style={{
                  border: 'none',
                  transform: `scale(${scale})`,
                  transformOrigin: 'center center',
                  cursor: 'grab'
                }}
                title="PDF Document"
              >
                <p>Unable to display PDF. <a href={pdfUrl} target="_blank" rel="noopener noreferrer">Download instead</a>.</p>
              </iframe>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PDFPreview;
